'use client';

import React, { useEffect, useRef, useState } from "react";
import { GetOnboardinData } from "@/store/questionniareSlice";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useRouter } from "next/router";
import { Box, Breadcrumbs, Button, Card, CardMedia, Grid, Paper, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import cssStyles from "@/components/onboarding/components/questioniar_component.module.scss";
import { navigateAndReplaceHistory, navigateWithHistory, trackItem } from "@/utils";
import { filterRooms3DdataByGlbUrl } from "@/components/onboarding/components/upload_your_home_instructions";
import ClientComponent from "../builder/client_component";
import Link from "next/link";
import ProjectCreationSuccessModal from "@/pages/[vendor]/roomplanonboarding/ProjectCreationSuccessModal";
import { createProject } from "@/store/projects";
import { getRoomDesigns } from "@/store/homeSlice";
import { CircularProgress } from '@mui/material';
import { gtmPageOnloadTracking, gtmClickTracking } from "@/utils";
import { Skeleton } from '@mui/material';
import { getUserTypeFromUrlLs } from "@/utils/useUserInfo";
import { useSearchParams } from "next/navigation";
import Image from "next/image";
type BreadCrumbData = {
  label: string;
  url?: string;
  type?: "link" | "text" | "button";
  onClick?: () => void; // Add the 'onClick' property to the type definition
};

type RoomData = {
  roomId: string;
  roomLabel?: string;
  roomType?: string;
  thumbnail?: string;
  glbUrl?: string;
  designStyle?: string;
  designId?: string;
  design?: any;
  isRoomQuizComplete?: boolean;
  projectData?: any[];
  origin?: string;
  room2dFloorWithDimensions?: string;
}

function extractFirstXElements(arr: any[], X: number, minArraySize: number): any[] {
  if (arr.length > minArraySize) {
    return arr.slice(0, X);
  }
  return [];
}

function groupByKey(roomsData: any, key: string) {
  return roomsData.reduce((grouped: any, eachRoom: any) => {
    const value = eachRoom[key];
    grouped[value] = grouped[value] || [];
    if (eachRoom.glbUrl != undefined || eachRoom.glbUrl != null || (eachRoom.thumbnail)) {
      grouped[value].push(eachRoom);
    }
    if (grouped[value].length == 0) {
      delete grouped[value];
    }
    return grouped;
  }, {});
}

const groupRoomsByRoomType = (roomsData: Array<any> = []) => {
  const groupedRooms = groupByKey(roomsData, 'roomTypeDisplayName');
  const recentRooms: any = extractFirstXElements(roomsData, 4, 8);
  if (recentRooms.length > 0) {
    groupedRooms['Most Recent Rooms'] = recentRooms;
  }
  const groupingOrder = ['Most Recent Rooms', 'Living Room', 'Bedroom', 'Dining Room', 'Home Office'];
  const sortedGroupedObject = groupingOrder.reduce((acc: { [key: string]: any[] }, key) => {
    if (groupedRooms[key]) {
      acc[key] = groupedRooms[key];
    }
    return acc;
  }, {});

  console.log('sortedGroupedObject------>', sortedGroupedObject);
  return sortedGroupedObject;
}

const MyRoomsComponent: React.FC = (props: any) => {
  console.log("MyRoomsComponent ---------: props : ", props);
  const router = useRouter();
  const brandPathEntry = '';
  const customerId = useRef("");
  const style = useRef(router.query.style as string);
  const designId = useRef(router.query.designId as string);

  const { rooms3Ddata, getRooms3DInfo } = GetOnboardinData();

  const [roomType, setRoomType] = useState<string | undefined>(router.query.roomType as string);
  const [roomId, setRoomId] = useState<string | undefined>(router.query.roomId as string);
  const [roomLabel, setRoomLabel] = useState<string | undefined>(router.query.roomLabel as string);
  const [showFloorPlan, setShowFloorPlan] = useState<boolean>(
    (router.query.ssrq == "true" || roomId || roomLabel || roomType) ? true : false);

  const [allRooms, setAllRooms] = useState<any[] | undefined>(undefined);
  const [showModal, setShowModal] = useState(false);
  const [roomData, setRoomData] = useState<any>(undefined);
  const [isMobile, setIsMobile] = useState(false);
  const [isLargeDesk, setisLargeDesk] = useState(false);
  const [hideProjectDetails] = useState<boolean>(props?.hideProjectDetails);
  const [roomTypeDisplayName] = useState<string | undefined>(props?.roomTypeDisplayName);
  const [design, setDesign] = useState<any>(props?.design);
  const [breadCrumbData, setBreadCrumbData] = useState<BreadCrumbData[]>([]);
  const [isLoaderVisible, setLoaderVisibility] = useState<boolean>(false);
  const [selectedBuilderImg, setSelectedBuilderImg] = useState<any>('');
  const [created_at, setCreated_at] = useState<any>('');
  const [groupedRoomsByType, setGroupedRoomsByType] = useState<any | null>(null);
  // sample room code start
  const {
    isInteriorDesigner,
    isProductSupplier,
    isCampaign,
    forDev
  } = getUserTypeFromUrlLs();
  // const isShowcase=router.query?.showcase==='true'
  const showCaseRoomType: any = router.query?.showCaseRoomType
  const [selectedTab, setSelectedTab] = useState<'myRooms' | 'sampleRooms'>(showCaseRoomType ? 'sampleRooms' : 'myRooms');

  const handleTabChange = (event: React.SyntheticEvent, newValue: 'myRooms' | 'sampleRooms') => {
    setSelectedTab(newValue);
  };
  const imageBaseUrl = "https://d2ffb7z1ailwvo.cloudfront.net/assets/images/sample-rooms/";
  const sampleRoomsData = {
    livingroom: [`${imageBaseUrl}Living1.png`, `${imageBaseUrl}Living2.png`, `${imageBaseUrl}Living3.png`],
    diningroom: [`${imageBaseUrl}Dining.png`, `${imageBaseUrl}Dining2.png`, `${imageBaseUrl}Dining3.png`],
    bedroom: [`${imageBaseUrl}Bedroom1d.png`, `${imageBaseUrl}Bedroom2.png`, `${imageBaseUrl}bedroom-3.png`],
    office: [`${imageBaseUrl}Homeoffice-1.png`, `${imageBaseUrl}Homeoffice-2.png`, `${imageBaseUrl}Homeoffice3.png`],
  };
  const sampeRoomsToShow = showCaseRoomType && sampleRoomsData[showCaseRoomType as keyof typeof sampleRoomsData]
    ? sampleRoomsData[showCaseRoomType as keyof typeof sampleRoomsData]
    : Object.values(sampleRoomsData).flat();
  // sample room code end

  console.log(`State :showFloorPlan: ${showFloorPlan}, roomType: ${roomType}, roomId: ${roomId}, roomLabel: ${roomLabel}`);

  const [builderLoading, setBuilderLoading] = useState(false);
  //Initiates the call to get the 3D rooms data or filters the specific room data from the 3D rooms data, if already fetched

  // useEffect(()=>{
  //   if(props?.hideProjectDetails && isMobile && groupedRoomsByType && groupedRoomsByType.length > 0){
  //     const firstKey = Object.keys(groupedRoomsByType)[0];
  //     const createdAt = groupedRoomsByType[firstKey]?.[0]?.created_at;
  //     setShowModal(true);
  //     setCreated_at(createdAt)
  //   }
  // },[groupedRoomsByType]);



  useEffect(() => {
    const data = groupRoomsByRoomType(allRooms); // Assume `groupRoomsByRoomType` is defined elsewhere
    setGroupedRoomsByType(data);
  }, [allRooms]);

  useEffect(() => {
    if (
      props?.hideProjectDetails &&
      isMobile &&
      groupedRoomsByType &&
      Object.keys(groupedRoomsByType).length > 0
    ) {
      const firstKey = Object.keys(groupedRoomsByType)[0];
      const createdAt = groupedRoomsByType[firstKey]?.[0]?.created_at;
      if (createdAt) {
        setCreated_at(createdAt);
        // setShowModal(true);
      }
    }
  }, [props?.hideProjectDetails, isMobile, groupedRoomsByType]);

  useEffect(() => {
    async function get3DRooms(customerId: string) {
      try {
        await getRooms3DInfo({
          roomType: roomType || "",
          customerID: customerId,
          roomLabel: roomLabel,
          roomId: roomId,
          mode: 'lite'
        });
      } catch (e) {
        console.log(e);
      }
    }
    if (props.userInfo !== null) {
      if (props.userInfo.unauthorized) {

        if (isInteriorDesigner) {
          window.location.href = `/interior-designer`;
        } else if (isProductSupplier) {
          window.location.href = `/product-supplier`;
        } else {
          localStorage.setItem('next', window.location.pathname + window.location.search);
          return navigateAndReplaceHistory(router, `/login`);
        }
      } else if (props.userInfo.cId) {
        customerId.current = props.userInfo.cId;

        if (showFloorPlan && roomData && (roomData.roomId === roomId || roomData.roomLabel === roomLabel)) {
          return; //already fetched
        } else if (allRooms && allRooms.length > 0) {
          if (showFloorPlan && !roomData) {
            let roomData = allRooms.filter(room => room.roomId === roomId || room.roomLabel === roomLabel)[0];
            if (!roomData && roomType) { // just to get the first room of the type
              roomData = allRooms.filter(room => room.roomType === roomType)[0];
            }
            setRoomData(roomData);
          }
        } else {
          get3DRooms(customerId.current);
        }
      }
    }
  }, [props.userInfo, roomType, roomId, roomLabel, showFloorPlan])


  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [])
  useEffect(() => {
    gtmPageOnloadTracking({
      event: 'Room list page view ',
      pageType: "Room list page view "
    });
  }
    , []);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767); // Detect mobile screen
    setisLargeDesk(window.innerWidth >= 1600); // Detect Large Desktop 1280px
  };
  const groupRoomsByRoomType = (roomsData: Array<any> = []) => {
    const groupedRooms = groupByKey(roomsData, 'roomTypeDisplayName');
    const recentRooms: any = extractFirstXElements(roomsData, 4, 8);
    if (recentRooms.length > 0) {
      groupedRooms['Most Recent Rooms'] = recentRooms;
    }
    const groupingOrder = ['Most Recent Rooms', 'Living Room', 'Bedroom', 'Dining Room', 'Home Office'];
    const sortedGroupedObject = groupingOrder.reduce((acc: { [key: string]: any[] }, key) => {
      if (groupedRooms[key]) {
        acc[key] = groupedRooms[key];
      }
      return acc;
    }, {});
    if (hideProjectDetails && roomTypeDisplayName) {
      let filteredObj: any = {};
      if (sortedGroupedObject[roomTypeDisplayName]) {
        filteredObj[roomTypeDisplayName] = sortedGroupedObject[roomTypeDisplayName];
      }
      return filteredObj;
    }
    return sortedGroupedObject;
  }
  //Hide 'See project details'
  // useEffect( ()=> {
  //   if(router.query && router.query.hideProjectDetails) {
  //     setHideProjectDetails(true);
  //   }
  // }, [router.query.createRoomPlan]);
  const handleProjects = async (roomType: any) => {
    let designProducts: any = await getRoomDesigns({ room: design.roomType, style: design.style });
    console.log("roomTypeee", roomType);
    setSelectedBuilderImg(roomType.thumbnail);
    setCreated_at(roomType.created_at);
    const projectPayload = {
      projectName: `${design.style} ${roomType.roomTypeDisplayName}`,
      roomModel: { roomType: roomType.roomTypeDisplayName },
      metaData: { roomType: roomType.roomTypeDisplayName, styleId: design.style, designId: design.designId, designImage: design.designImages },
      products: designProducts,
      origin: 'DESIGN',
      isInternalUser: typeof localStorage != "undefined" && localStorage.getItem('trafficType') === 'internal'
    }
    const project = await createProject(projectPayload);
    //debugger;
    return project;
  }

  //Callback listener for the 3D rooms data, which initiates the floor plan view or my rooms view
  useEffect(() => {
    if (!rooms3Ddata || Object.keys(rooms3Ddata).length <= 0) {
      return;
    } else {
      let roomsData = rooms3Ddata.rooms || [];
      if (showFloorPlan) {
        let roomData = roomsData.filter((room: RoomData) => room.roomId === roomId || room.roomLabel === roomLabel)[0];
        if (!roomData && roomType) { // just to get the first room of the type
          roomData = roomsData.filter((room: RoomData) => room.roomType === roomType)[0];
        }
        if (roomData) {
          goToFloorPlanView(null, roomData);
          return;
        }
      }
      setAllRooms(filterRooms3DdataByGlbUrl(roomsData));
      //TODO : commented as it is removing the userType=supplier param,  need more regression testing for this
      //showMyRoomsView();
    }
  }, [rooms3Ddata, roomType, roomId, roomLabel, showFloorPlan]);

  useEffect(() => {
    setRoomId(router.query.roomId as string);
    setRoomLabel(router.query.roomLabel as string);
    setRoomType(router.query.roomType as string);
    setShowFloorPlan(router.query.ssrq == "true" || roomId || roomLabel || roomType ? true : false);
    window.scrollTo({ top: 0 })
  }, [router.query.roomId, router.query.roomLabel, router.query.roomType, router.query.ssrq]);


  const goToFloorPlanView = (e: any, room: any) => {
    setRoomData(room);
    updateBreadCrumbData(room, true);
    router.push({ pathname: `${brandPathEntry}/myrooms`, query: { ssrq: true, roomType: room.roomType, roomId: room.roomId, roomLabel: room.roomLabel } });
  }

  const goToBuilder = (roomId?: string) => {
    console.log("go to builder function called");
    gtmClickTracking({
      event: 'selects a room',
      pageType: 'selects a room',
    })
    setBuilderLoading(true);
    navigateWithHistory(router, `/builder?roomId=${roomId}`)
  }

  const goToNextSetp = (room: any) => {
    setBuilderLoading(true);
    navigateWithHistory(router, nextSteps(room, false)?.[0]?.destination);
  }

  const showMyRoomsView = () => {
    setRoomData(undefined);
    router.push({ pathname: `${brandPathEntry}/myrooms`, query: isInteriorDesigner ? { userType: 'designer', ...(router.query?.showCaseRoomType && { showCaseRoomType: router.query?.showCaseRoomType }) } : {} }, undefined, { shallow: false });
  }

  const onCloseOverlay = () => {
    setShowModal(false);
    navigateWithHistory(router, `/projects`)
  }

  const updateBreadCrumbData = (room: RoomData, showFloorPlan: boolean = false) => {
    let breadCrumbData: BreadCrumbData[] = [];
    breadCrumbData.push({ label: "Home", url: brandPathEntry || "/" });
    if (showFloorPlan) {
      breadCrumbData.push({ label: "My Rooms", onClick: showMyRoomsView });
      breadCrumbData.push({ label: room.roomLabel || room.roomType || '', type: "text" });
    } else {
      breadCrumbData.push({ label: "My Rooms", type: "text" });
    }
    setBreadCrumbData(breadCrumbData);
  }

  /*
   * in the future, capture all the possible next steps for this room and return.
   * currently only one step is implemented.
   *
   */
  const nextSteps = (room: any, isFloorPlanDetailPage: boolean) => {
    if (!room) {
      return;
    }
    const nextStepsData: { [key: string]: any }[] = [];
    const step: { [key: string]: any } = {};
    step.destination = '';
    if (brandPathEntry) {
      step.destination = `/${brandPathEntry}`;
    }
    step.text = "Start designing!";
    if (isInteriorDesigner) {
      step.destination += `/builder?roomId=${room.roomId}&interiorDesigner=true`;
    }
    else if (room.glbUrl != null && !hideProjectDetails) {
      step.destination += `/builder?roomId=${room.roomId}`;
    } else if (room.projectData?.length > 0) {
      step.destination += `/builder?projectId=${room.projectData[0].projectId}`;
    }
    else if (!room.designId && !designId.current && !design && !hideProjectDetails) {
      step.destination += `/myInspirations?roomid=${room.roomId}&roomtype=${room.roomType}`;
    } else {
      step.destination += `/builder?roomId=${room.roomId}&roomType=${room.roomType}&designId=${design.designId}`;
    }

    nextStepsData.push(step);

    nextStepsData.forEach((step) => {
      if (room.designId || designId.current) {
        step.destination += `&designId=${room.designId || designId.current}`;
      }
    });

    return nextStepsData;
  }

  const renderRoomAction = (room: any, isFloorPlanDetailPage: boolean, isLink: boolean = false) => {
    if (!room) {
      return;
    }
    const nextStepsData: any = nextSteps(room, isFloorPlanDetailPage);
    //for now retrieve the first step. in the future we will have multiple steps we need to iterate on.
    const text = nextStepsData[0].text;
    const destination = nextStepsData[0].destination;
    console.log('text:', text, 'destination:', destination);

    return (
      isLink ?
        <Typography sx={{ color: 'primary.main', fontWeight: 'bolder', fontSize: '16px' }}>
          {text}
        </Typography>
        :
        <Button className={cssStyles["next-button"]}
          color="primary"
          href={destination} onClick={() => { trackItem({ event: 'MyRoomClick2', name: room.roomLabel || room.roomType || '' }) }}
          sx={{ display: 'flex', textTransform: 'none', margin: '10px auto', cursor: 'pointer' }}>
          {text}
        </Button>
    )
  }
  // debugger
  // const data = groupRoomsByRoomType(allRooms);
  // if(!groupedRoomsByType) {
  //   setGroupedRoomsByType(data);
  // }
  // console.log('groupRoomsByRoomType data: ', data)

  const data = groupRoomsByRoomType(allRooms);
  console.log('groupRoomsByRoomType data: ', data)

  if (builderLoading) {
    return (
      <div>
        <div style={{ height: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="h4" style={{ textAlign: 'center', fontSize: '16px' }}>
            Preparing an immersive experience. Please wait...
          </Typography>
        </div>
      </div>
    )
  } else if (showFloorPlan && roomData) {

    let glbUrl = roomData?.glbUrl || '';
    if (roomData.origin == "web" && roomData.thumbnail) {
      glbUrl = roomData.thumbnail;
    }
    return (
      <>
        <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="large" />}>
          {
            breadCrumbData.map((data, index) => {
              return (
                <Box component="div" key={`$bc-label-${index}`}>
                  <a href={data.url} onClick={data.onClick} style={{ cursor: data.type == 'text' ? "" : "pointer" }}>
                    <Typography color="text.primary" fontSize={'14px'}>{data.label}</Typography>
                  </a>
                </Box>
              )
            })
          }
        </Breadcrumbs>
        <div id="2doverlay" style={{ display: 'flex', justifyContent: "center", flexDirection: 'row', flexWrap: "wrap" }}>
          {(!glbUrl) ?
            <Typography variant="h2" align="left" style={{ paddingBottom: '20px' }}>
              No {roomType} floorplan found. {roomData.isRoomQuizComplete ? "Check few recommendations" : "Would you like to take Room quiz instead"}
            </Typography>
            :
            (<>
              <Typography variant="h1" align="left" style={{ margin: '20px 0' }}>
                {roomLabel || roomType} floorplan is ready!
              </Typography>
              <Paper sx={{ padding: '10px', margin: '0 5px', width: '100%', textAlign: 'center' }} elevation={0} square>
                <img style={{ maxHeight: 'calc(100vh - 300px)', maxWidth: '100%' }} src={roomData.thumbnail} alt={roomData.thumbnail ? "floor plan thumbnail" : "Unable to load Floor Plan View "} />
              </Paper>
            </>)
          }

          <Paper sx={{ padding: '5px 30px', margin: '0 5px', width: '100%' }} elevation={0} square>
            {renderRoomAction(roomData, true, false)}
          </Paper>

        </div></>)
  } else if (allRooms) {
    if (isLoaderVisible) {
      return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '59vh'
        }}>
          <CircularProgress color="inherit" />
        </div>
      );
    }

    const renderRooms = () => {
      if (allRooms && allRooms.length === 0 && Object.keys(data).length === 0) {
        return (
          <div style={{ height: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant="h4" style={{ textAlign: 'center', fontSize: '16px' }}>
              No Rooms...
            </Typography>
          </div>)
      }
      const roomCardElements = Object.keys(data).map((roomType) => {
        return (
          <React.Fragment key={roomType}>
            <Grid container spacing={4} key={roomType}>
              <Grid item xs={12}>
                <Typography variant="h2" align="left" style={{ borderBottom: "1px solid lightgray", marginTop: "20px" }}>
                  {`${roomType} (${data[roomType].length}):`}
                </Typography>
              </Grid>
              {
                data[roomType].map((room: any) => {
                  return (
                    <Grid item key={room.roomId} xs={12} sm={6} md={4} lg={3}>
                      <Link href={!isMobile && nextSteps(room, false)?.[0]?.destination || ''}
                        onClick={async () => {
                          await gtmClickTracking({
                            event: 'selects a room',
                            pageType: 'selects a room',
                          })
                          if (isMobile) {
                            await setLoaderVisibility(true)
                            await handleProjects(room);
                            await setLoaderVisibility(false)
                            await setShowModal(true);
                            await gtmClickTracking({
                              event: 'Project created page view',
                              pageType: 'Project created page view',
                            })
                          }
                        }}>
                        <Box
                          component="div"
                          sx={{
                            cursor: 'pointer',
                            width: '300px',
                            height: '300px',
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'relative',
                            borderRadius: '10px',
                            overflow: 'hidden',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            backgroundColor: '#dFdFdF',
                            border: 'solid 1px rgba(0,0,0,0.8)',
                            '&:hover': {
                              'boxShadow': '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
                              "& .inner-box": {
                                display: 'flex'
                              }
                            }
                          }}
                        >
                          <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '250px',
                          }}>
                            <img src={room.thumbnail} alt={decodeURIComponent(room.roomLabel)} style={{
                              maxWidth: '100%',
                              maxHeight: '100%',
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover'
                            }}
                            />
                          </div>
                          <Box className="inner-box" component="div" sx={{
                            display: { xs: 'flex', sm: 'flex', md: 'none' },
                            position: 'absolute',
                            bottom: '48px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: '50px',
                            textDecoration: 'none',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)'
                          }} >
                            <Typography sx={{ color: 'primary.main', fontWeight: 'bolder', fontSize: '16px' }}>
                              Start designing!
                            </Typography>
                          </Box>
                          <div style={{
                            display: 'flex',
                            backgroundColor: '#7F7F7F',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '50px',
                            fontSize: '16px',
                            padding: '5px',
                            fontWeight: 'bold'
                          }} className={'roomAction'}>
                            <Typography variant="h2" style={{ color: "white", display: 'inline', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                              {decodeURIComponent(room.roomLabel)}
                            </Typography>
                          </div>
                        </Box>
                      </Link>
                    </Grid>)
                })
              }
            </Grid>
            {
              showModal
              &&
              <ProjectCreationSuccessModal
                onCloseOverlay={onCloseOverlay}
                designImage={design.designImages}
                builderImg={selectedBuilderImg}
                createdAt={created_at}
              />
            }
          </React.Fragment>)

      })
      return roomCardElements.length > 0 ? <>{roomCardElements}</> : <>No Rooms Found</>;
    }
    // sample room code start

    const renderShowCaseRooms = (showCaseRoomType: any) => {
      return (
        <Box component='div'>
          {showCaseRoomType ? (
            // Render specific room type section
            <Box mb={4} component='div'>
              <Typography variant="h6" gutterBottom sx={{ textTransform: 'capitalize', fontSize: '16px', borderBottom: "1px solid lightgray", marginBottom: '20px' }}>
                {showCaseRoomType}
              </Typography>
              <Grid container spacing={4}>
                {sampleRoomsData[showCaseRoomType as keyof typeof sampleRoomsData]?.map((image, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Card sx={{ borderRadius: 2, boxShadow: 2, height: '300px', width: '300px' }}>
                      <a href={`/builder?showcase=true&auth=false&roomType=${encodeURIComponent(`${showCaseRoomType}${index + 1}`)}&interiorDesigner=true`}>
                        <Image
                          src={image}
                          alt={image}
                          style={{ objectFit: 'cover' }}
                          height={300}
                          width={300}
                        />
                      </a>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : (
            // Render all room types with headings
            Object.entries(sampleRoomsData).map(([roomType, images]) => (
              <Box key={roomType} mb={5} component='div'>
                <Typography variant="h6" gutterBottom sx={{ textTransform: 'capitalize', fontSize: '16px', borderBottom: "1px solid lightgray", marginBottom: '20px' }}>
                  {roomType}
                </Typography>
                <Grid container spacing={4}>
                  {images.map((image, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <Card sx={{ borderRadius: 2, boxShadow: 2, height: '300px', width: '300px' }}>
                        <a href={`/builder?showcase=true&auth=false&roomType=${encodeURIComponent(`${roomType}${index + 1}`)}&interiorDesigner=true`}>
                          <Image
                            src={image}
                            alt={image}
                            style={{ objectFit: 'cover' }}
                            height={300}
                            width={300}
                          />
                        </a>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ))
          )}
        </Box>
      );
    }
    if (isInteriorDesigner) {
      return (
        <Box component='div'>
          <Tabs value={selectedTab} onChange={handleTabChange} sx={{ marginBottom: 2 }}>
            <Tab value="myRooms" label="My Rooms" sx={{ fontSize: '14px', marginLeft: 0 }} />
            <Tab value="sampleRooms" label="Sample Rooms" sx={{ fontSize: '14px' }} />
          </Tabs>

          {selectedTab === 'myRooms' ? renderRooms() : null}
          {selectedTab === 'sampleRooms' ? renderShowCaseRooms(showCaseRoomType) : null}
        </Box>
      );
    }
    // sample room code end

    return renderRooms()

  } else {
    return (
      <div style={{ height: '80vh', padding: '20px' }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Skeleton variant="text" width="40%" height={40} />
          </Grid>
          {[1, 2, 3, 4].map((item) => (
            <Grid item key={item} xs={12} sm={6} md={4} lg={3}>
              <Box component='div' sx={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}>
                <Skeleton variant="rectangular" width="100%" height={250} sx={{ borderRadius: '10px 10px 0 0' }} />
                <Skeleton variant="rectangular" width="100%" height={50} sx={{ borderRadius: '0 0 10px 10px' }} />
              </Box>
            </Grid>
          ))}
          <Grid item xs={12} sx={{ mt: 4 }}>
            <Skeleton variant="text" width="40%" height={40} />
          </Grid>
          {[1, 2, 3, 4].map((item) => (
            <Grid item key={`second-${item}`} xs={12} sm={6} md={4} lg={3}>
              <Box component='div' sx={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}>
                <Skeleton variant="rectangular" width="100%" height={250} sx={{ borderRadius: '10px 10px 0 0' }} />
                <Skeleton variant="rectangular" width="100%" height={50} sx={{ borderRadius: '0 0 10px 10px' }} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </div>
    )
  }
}

export default ClientComponent(MyRoomsComponent);